import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { SectionEyebrow } from "@/components/section-eyebrow";

type FaqItem = {
  question: string;
  answer: string;
};

type Props = {
  items: FaqItem[];
  eyebrow?: string;
  title?: string;
};

export function FaqSection({
  items,
  eyebrow = "FAQ",
  title = "Frequently asked questions",
}: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  if (!items || items.length === 0) return null;

  return (
    <section className="px-6 py-24">
      <div className="max-w-3xl mx-auto">
        <div className="mb-10 text-center">
          <SectionEyebrow className="mx-auto inline-block">{eyebrow}</SectionEyebrow>
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-white text-balance mt-3">
            {title}
          </h2>
        </div>

        <div className="space-y-3">
          {items.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className="glass-card overflow-hidden transition-all duration-300"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-base font-medium text-white">{item.question}</span>
                  <ChevronDown
                    className={`size-5 text-pink-soft shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-white/75 leading-relaxed text-pretty">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
